export const plural = (key, count, params, _locale, getTranslation) => {
      const translation = getTranslation(key, params);
      if (!translation) {
        return null;
      }
      const forms = translation.toString().split("|");
      if (forms.length === 0) return null;
      const selectedForm = count < forms.length ? forms[count] : forms[forms.length - 1];
      if (!selectedForm) return null;
      return selectedForm.trim().replace("{count}", count.toString());
    };